export default "__VITE_ASSET__adf672ff__"